
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_1mfbn_elr7r_9",
  "grid-cell": "awsui_grid-cell_1mfbn_elr7r_14",
  "day-header": "awsui_day-header_1mfbn_elr7r_21",
  "day": "awsui_day_1mfbn_elr7r_21",
  "month": "awsui_month_1mfbn_elr7r_32",
  "day-inner": "awsui_day-inner_1mfbn_elr7r_80",
  "month-inner": "awsui_month-inner_1mfbn_elr7r_81",
  "in-first-row": "awsui_in-first-row_1mfbn_elr7r_88",
  "in-previous-month": "awsui_in-previous-month_1mfbn_elr7r_88",
  "in-previous-year": "awsui_in-previous-year_1mfbn_elr7r_89",
  "last-day-of-month": "awsui_last-day-of-month_1mfbn_elr7r_93",
  "last-month-of-year": "awsui_last-month-of-year_1mfbn_elr7r_94",
  "in-next-month": "awsui_in-next-month_1mfbn_elr7r_98",
  "in-next-year": "awsui_in-next-year_1mfbn_elr7r_99",
  "in-first-column": "awsui_in-first-column_1mfbn_elr7r_103",
  "in-visible-calendar": "awsui_in-visible-calendar_1mfbn_elr7r_106",
  "in-current-month": "awsui_in-current-month_1mfbn_elr7r_106",
  "in-current-year": "awsui_in-current-year_1mfbn_elr7r_106",
  "enabled": "awsui_enabled_1mfbn_elr7r_110",
  "in-range": "awsui_in-range_1mfbn_elr7r_116",
  "end-date": "awsui_end-date_1mfbn_elr7r_116",
  "start-date": "awsui_start-date_1mfbn_elr7r_116",
  "no-range": "awsui_no-range_1mfbn_elr7r_116",
  "selected": "awsui_selected_1mfbn_elr7r_126",
  "today": "awsui_today_1mfbn_elr7r_131",
  "this-month": "awsui_this-month_1mfbn_elr7r_132",
  "in-range-border-block-start": "awsui_in-range-border-block-start_1mfbn_elr7r_188",
  "in-range-border-inline-end": "awsui_in-range-border-inline-end_1mfbn_elr7r_191",
  "in-range-border-block-end": "awsui_in-range-border-block-end_1mfbn_elr7r_194",
  "in-range-border-inline-start": "awsui_in-range-border-inline-start_1mfbn_elr7r_197"
};
  